// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'e50c0600f391329493284ffded48174a4c30d6d5';
export const BUILD_NUMBER = '256';
export const BUILD_TIMESTAMP = '2026-09-30T06:53:24.945Z';
